import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const tabbedAccordionFields = `
  _id,
  _type,
  title,
  subtitle,
  color,
  image {
    ${imageFields}
  },
  align,
  tabs[]{
    _type,
    title,
    "content": items[]{
      _type,
      title,
      content[]
    }
  }
`

export const TABBED_ACCORDION_QUERY = defineQuery(/* groq */ `
  *[_type == "tabbed-accordion"][0]{
    ${tabbedAccordionFields}
  }
`)
